<template>
    <va-create-layout>
        <SellerReviewEnrollmentPaymentEventCharge-form
            :title="title"
            :item="item"
        ></SellerReviewEnrollmentPaymentEventCharge-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
